import axiosInstance from './axiosinstance';
import { API_ENDPOINTS } from './urls';
import { getGameDetails } from '../LocalStorageService';

export const doJoinGame = async (data) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: API_ENDPOINTS.REGISTER_PLAYER,
      data,
    });
    return response; // Response is already `response.data` from the interceptor
  } catch (error) {
    // Rethrow error for higher-level handling

    throw error;
  }
  //throw error;
};

export const fetchActivePlayers = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.ACTIVE_PLAYERS}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    // Rethrow error for higher-level handling
    throw error;
  }
};
export const fetchGameDetailsStats = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.FETCH_GAME_DETAIL_STATISTICS}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    // Rethrow error for higher-level handling
    throw error;
  }
};

export const fetchLeaderBoard = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.FETCH_GAME_DETAIL_STATISTICS}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    // Rethrow error for higher-level handling
    throw error;
  }
};
export const fetchNextQuestion = async (data) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.NEXT_QUESTION,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const startGame = async (data) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.HOST_START_GAME,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const submitQuestion = async (data: SubmitAnswerModel) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.SUBMIT_QUESTION,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchLeaderBoardStream = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.FETCH_LEADERBOARD}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchGameStatusStream = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.FETCH_GAME_STATUS}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchCurrentQuizStream = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.HOST_FETCH_QUESTION}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchTopThreeGeoFinalistStream = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.GEO_TOP_3_PLAYERS_SUMMARY}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchGeoLeaderBoard = async (data: GeoRquest) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.GEO_LEADER_BOARD,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchNextGeo = async (data: GeoRquest) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.GEO_NEXT_PLAY,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchGeoStatistics = async (data: GeoRquest) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.GEO_PLAYER_SESSION,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const submitGeoPlay = async (data: GeoSubmitRequest) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.SUBMIT_GEO_PLAY,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const getCountry = async (
  latitude: string,
  longitude: string
): Promise<string | undefined> => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_GEO_REVERSE_API_URL}?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
    );
    return response.json();
  } catch (error) {
    throw error;
  }
};
export const fetchCountry = async () => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.COUNTRY_API}`,
      method: 'GET',
    });
    return response.data.country;
  } catch (error) {
    throw error;
  }
};

export const fetchQrCode = async (gameId: string) => {
  try {
    const response = await axiosInstance({
      url: `${API_ENDPOINTS.GET_QR_CODE}/${gameId}`,
      method: 'GET',
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const submitSketcher = async (data: SubmitSketcherRequest) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.SKETCHER_SUBMIT,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createSketcherGame = async (data: CreateSketcherGameRequest) => {
  try {
    const response = await axiosInstance({
      url: API_ENDPOINTS.CREATE_SKETCHER_GAME,
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
